import { render, staticRenderFns } from "./schoolAccessAudit2.vue?vue&type=template&id=13fa14d4&scoped=true&"
import script from "./schoolAccessAudit2.vue?vue&type=script&lang=js&"
export * from "./schoolAccessAudit2.vue?vue&type=script&lang=js&"
import style0 from "./schoolAccessAudit2.vue?vue&type=style&index=0&id=13fa14d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fa14d4",
  null
  
)

export default component.exports